import Marquee from "react-fast-marquee";

const ITEMS = [
  "ZERO BUGS",
  "1-WEEK DELIVERY",
  "MINIMAL COST",
  "MARKET READY",
  "AI ARCHITECTED",
  "HUMAN-ERROR FREE",
];

export default function MarqueeStrip() {
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-black/10 bg-[#f3f1ec] py-5"
    >
      <Marquee speed={40} gradient={false}>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span
            key={i}
            className="font-mono text-sm uppercase tracking-[0.25em] text-[#52525b] mx-10 inline-flex items-center"
          >
            {t}
            <span className="mx-10 text-[#1f87bc]">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
